import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const Header = ({ goBack, step }) => {
  if (step === 'saved-cards')
    return (
      <div className="flex flex-wrap items-center gap-1">
        <Typography
          variant="label"
          color="neutral-800"
          weight="semibold"
          size="large"
          className="!text-xl capitalize">
          Pay estimate now
        </Typography>
      </div>
    );

  return (
    <div className="flex flex-wrap items-center gap-1">
      <Icon icon="arrow-left-linear" onClick={goBack} />
      <Typography
        variant="label"
        color="neutral-800"
        weight="semibold"
        size="medium"
        className="capitalize">
        Pay estimate now
      </Typography>
      <Typography
        variant="label"
        color="neutral-800"
        weight="semibold"
        size="medium"
        className="capitalize">
        / New card
      </Typography>
    </div>
  );
};

export default Header;
